import { Href } from 'components/ui/Href/Href'
import { Title } from 'components/ui/Title/Title'

import s from './BankingServicesItem.module.scss'

type BankingServicesItemProps = {
  id: number
  title: string
  imgUrl: string
  link: string
}

const BankingServicesItem = ({ title, imgUrl, id, link }: BankingServicesItemProps) => {
  return (
    <li className={s.BankingServicesItem} key={id}>
      <Href href={link} linkType="search" className={s.link}>
        <Title className={s.title}>{title}</Title>
        <img src={imgUrl} alt={title} className={s.img} />
      </Href>
    </li>
  )
}

export default BankingServicesItem
